<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" md="12" lg="12" xl="12">
        <h5 class="mb-0">{{ $t("Кунлик айланма")}}</h5>
      </b-col>
      <b-col lg="3" class="my-1">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="form-control" type="date" v-model="datas.date1" />
      </b-col>
      <b-col lg="3" class="my-1">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="form-control" type="date" v-model="datas.date2" />
      </b-col>
      <b-col lg="2" class="my-1">
        <label>Склад</label>
        <v-select class="form-control-sm md-input" :options="skladlist" :clearable=false :disabled="skladhave"
          v-model="datas.sklad_id" :reduce="name => name.id" label="name">
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </b-col>
      <b-col lg="4" class="my-1">
        <br /><button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> {{ $t("Excel(Юклаш)") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print()">
          <b-icon icon="printer"></b-icon>
        </button>
      </b-col>
      <div class="limiter" id="tableId">
        <div class="container-table100">
          <div class="wrap-table100">
            <div class="table100 ver1 m-b-110">
              <div class="table100-head">
                <table>
                  <thead>
                    <tr class="row100 head">
                      <th class="cell100 column2">
                        {{ $t("Вақт") }}
                      </th>
                      <th class="cell100 column1">
                        {{ $t("Валюта") }}
                      </th>
                      <th class="cell100 column2">
                        {{ $t("Нахд") }}
                      </th>
                      <th class="cell100 column2">
                        Доллар
                      </th>
                      <th class="cell100 column2">Пластик</th>
                      <th class="cell100 column2">Перечесления</th>
                      <th class="cell100 column3">
                        {{ $t("Насия") }}
                      </th>
                      <th class="cell100 column2">Скидка</th>
                      <th class="cell100 column4">
                        {{ $t("Жами") }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <h2 v-if="empty==true" style="background-color: rgb(224, 171, 171);text-align: center;">
                {{$t('Операция йўқ')}}
              </h2>
              <div class="table100-body js-pscroll">
                <table>
                  <tbody v-for="(itemname, inde) in results" :key="inde">
                    <tr class="row100 body summatable1">
                      <td colspan="9">{{itemname.name}} <b-button v-b-toggle="'collapse-' + inde">+</b-button></td>
                    </tr>
                    <b-collapse :id="'collapse-' + inde">
                      <span style="display: contents;" v-for="(item1, index1) in itemname.months" :key="index1"
                        v-if="index1!='null'">
                        <tr class="row100 body summatable1">
                          <td class="cell100 column2">
                            {{
                            new Date(index1).toLocaleString("ru-Ru", {
                            month: "long"
                            })
                            }}
                          </td>
                          <td class="cell100 column1">
                          </td>
                          <td class="cell100 kol column2">{{ Setted(item1)|numFormats }}</td>
                          <td class="cell100 kol column2">
                            {{ item1.dollar | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item1.plastik | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item1.shot_summa | numFormats }}
                          </td>
                          <td class="cell100 kol column3">
                            {{ item1.nasiya | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item1.skidka | numFormats }}
                          </td>
                          <td class="cell100 kol column4">
                            {{ item1.total | numFormats }}
                          </td>
                        </tr>
                        <tr class="row100 body" v-for="(item, index) in item1" :key="index">
                          <td class="cell100 column2">{{ item.day }}</td>
                          <td class="cell100 column1">
                            <span v-if="item.pay_type_id==3">
                              Доллар
                            </span>
                            <span v-else>
                              Сўм
                            </span>
                          </td>
                          <td class="cell100 kol column2">
                            {{ item.total_cash | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item.total_dollar | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item.total_plastic | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item.total_shot | numFormats }}
                          </td>
                          <td class="cell100 kol column3">
                            {{ item.total_credit | numFormats }}
                          </td>
                          <td class="cell100 kol column2">
                            {{ item.total_skidka | numFormats }}
                          </td>
                          <td class="cell100 kol column4">
                            {{ item.total | numFormats }}
                          </td>
                        </tr>
                      </span>
                      <span v-else>
                        {{$t('Маьлумот йўқ')}}
                      </span>
                    </b-collapse>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <paytype :datas="datas"></paytype>
    <sklad :datas="datas"></sklad>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
  </b-container>
</template>

<script>
  var XLSX = require("xlsx");
  var FileSaver = require("file-saver");
  import { print } from "../../../components/mixins/print.js";
  import { Paytype, Unit, Model, Brand, Colour, Sklad } from "@/pages";
  export default {
    components: { Paytype, Unit, Model, Brand, Colour, Sklad },
    mixins: [print],
    data() {
      return {
        datas: {
          date1: new Date().toISOString().slice(0, 8) + "01",
          date2: new Date().toISOString().slice(0, 10),
          pay_type_id: null,
          sklad_id: parseInt(localStorage.getItem("sklad_id"))
        },
        paytype: "",
        paytypelist: [],
        sklad: "",
        skladlist: [],
        pricesettings: [],
        errors: "",
        results: []
      };
    },
    created() {
      let self = this;
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.Pricesettings();
    },
    methods: {
      Setted: function (item1) {
        let self = this;
        item1.total = 0;
        item1.naqd = 0;
        item1.plastik = 0;
        item1.skidka = 0;
        item1.nasiya = 0;
        item1.shot_summa = 0;
        item1.dollar = 0
        item1.forEach(function (key, value) {
          if (key.total == null) {
            key.total=0;
          }
          if (self.pricesettings.common_price_type == 1) {
              if (key.pay_type_id != 3) {
                item1.total += key.total;
              } else {
                item1.total += key.total * key.dollar_rate;
              }
          } else {
              if (key.pay_type_id != 3 && key.dollar_rate>0) {
                item1.total += (key.total / key.dollar_rate);
              } else {
                item1.total += key.total;
            }
          }
          item1.naqd += key.total_cash;
          if (self.pricesettings.common_price_type == 1) {
              if (key.pay_type_id != 3) {
                item1.nasiya += key.total_credit;
              } else {
                item1.nasiya += key.total_credit * key.dollar_rate;
            }

          } else {
              if (key.pay_type_id != 3) {
                if(key.total_credit!=0 && key.dollar_rate>0){
                item1.nasiya += (key.total_credit / key.dollar_rate);
                }
              } else {
                item1.nasiya += key.total_credit;
              }
          }
          item1.plastik += key.total_plastic;
          if (key.total_shot != null) {
            item1.shot_summa += key.total_shot;
          }
          item1.skidka += key.total_skidka;
          item1.dollar += key.total_dollar;
        });
        return item1.naqd;
      },
      downloadExl() {
        this.$store.state.xls=true;
       setTimeout(() => {
         let wb = XLSX.utils.table_to_book(document.getElementById("tableId")),
           wopts = {
             bookType: "xlsx",
             bookSST: false,
             type: "binary"
           };
         var wscols = [{ width: 20 }, { width: 7 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }];
         wb.Sheets.Sheet1['!cols'] = wscols;
         let wbout = XLSX.write(wb, wopts);
         FileSaver.saveAs(
           new Blob([this.s2ab(wbout)], {
             type: "application/octet-stream;charsetted=utf-8"
           }),
           new Date() + "kunlik_aylanma.xlsx"
         );
         setTimeout(() => {
           this.$store.state.xls=false;
         }, 2000);
       }, 1000);
      },
      Pricesettings() {
        let self = this;
        axios.get("api/v1/sklads/id/1").then(function (response) {
          self.pricesettings = { common_price_type: response.data.common_price_type, chakana_price_type: response.data.chakana_price_type, optom_price_type: response.data.optom_price_type };
        });
      },
      s2ab(s) {
        if (typeof ArrayBuffer !== "undefind") {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        } else {
          var buf = new Array(s.length);
          for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }
      },
      Send() {
        let self = this;
        var datas = {
          datetime1: parseInt(
            new Date(self.datas.date1)
              .valueOf()
              .toString()
              .slice(0, 10)
          ),
          datetime2:
            parseInt(
              new Date(self.datas.date2)
                .valueOf()
                .toString()
                .slice(0, 10)
            ) + 86399,
          sklad_id: self.datas.sklad_id
        };
        axios({
          method: "post",
          url: "api/v1/report/daily-rasxod",
          headers: {
            "Content-Type": "application/json"
          },
          data: datas
        }).then(function (response) {
          if (Object.keys(response.data).length == 0) {
            self.empty = true;
          } else {
            self.empty = false;
          }
          self.results = response.data;
        });
      }
    }
  };
</script>
<style scoped>
  .table100-body {
    max-height: 77vh;
  }
</style>